import dataExplorerSaga from './DataExplorer';
import schemaExplorerSaga from './SchemaExplorer';

export const dbServiceSagas = () => [
  schemaExplorerSaga(),
  dataExplorerSaga()
];

export default dbServiceSagas;
